import { AIAgent } from '../types';

// No seed agents — marketplace displays only real user-deployed replicas from the backend
export const agents: AIAgent[] = [];

export const categories = ['All', 'HR', 'Marketing', 'Finance', 'Customer Service'] as const;
